"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameSlideAnswer = exports.GameSlideAnswerProperties = void 0;
var enums_1 = require("./enums");
var game_answer_variant_1 = require("./game-answer-variant");
exports.GameSlideAnswerProperties = ['id', 'user_id', 'task_id', 'slide_id', 'is_skipped', 'with_hints', 'state', 'total_points', 'max_points'];
var GameSlideAnswer = /** @class */function () {
  function GameSlideAnswer(values) {
    if (values === void 0) {
      values = {};
    }
    this.state = enums_1.GameSlideAnswerStateEnum.unchecked;
    this.variants = [];
    /** количество очков за ответ */
    this.total_points = 0;
    /** максимальное количество очков за ответ */
    this.max_points = 0;
    var properties = exports.GameSlideAnswerProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('variants' in values) {
      instance.variants = values.variants.map(function (v) {
        return new game_answer_variant_1.GameAnswerVariant(v);
      });
    }
  }
  Object.defineProperty(GameSlideAnswer.prototype, "is_answered", {
    get: function () {
      return this.state !== enums_1.GameSlideAnswerStateEnum.unchecked;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameSlideAnswer.prototype, "is_correct", {
    get: function () {
      return enums_1.GameSlideAnswerStateEnum.correct === this.state;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameSlideAnswer.prototype, "is_partial", {
    get: function () {
      return enums_1.GameSlideAnswerStateEnum.partial === this.state;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameSlideAnswer.prototype, "is_wrong", {
    get: function () {
      return enums_1.GameSlideAnswerStateEnum.wrong === this.state;
    },
    enumerable: false,
    configurable: true
  });
  GameSlideAnswer.prototype.getVariant = function (id) {
    return this.variants.find(function (v) {
      return v.variant_id === id;
    });
  };
  GameSlideAnswer.prototype.addVariant = function (id) {
    if (!this.getVariant(id)) {
      this.variants.push(new game_answer_variant_1.GameAnswerVariant({
        variant_id: id
      }));
    }
  };
  GameSlideAnswer.prototype.removeVariant = function (id) {
    this.variants = this.variants.filter(function (v) {
      return v.variant_id !== id;
    });
  };
  GameSlideAnswer.prototype.clearVariants = function () {
    this.variants = [];
  };
  return GameSlideAnswer;
}();
exports.GameSlideAnswer = GameSlideAnswer;
